<div>
  <h5 class="m-t-15" id="question_name">
    <span>{{ question.name }}</span>
  </h5>
</div>
<div class="card-body" [ngClass]="(getIsNumberForm())?'question-number-body':'question-text-body'">
</div>